import { gql } from '@apollo/client';
import { DOCUMENT_FRAGMENT } from './document.fragments';
import { BASE_PARTNER_COMPANY_FRAGMENT } from './partner.fragments';
import { BASE_FARM_SITE_FRAGMENT } from './site.fragments';

export const BASE_PLOT_FRAGMENT = gql`
  fragment basePlotValues on Plot {
    id
    farmId
    sizeHa
    title
    externalId
    createdTimestamp
    isAgroforestry
    feature {
      type
      geometry {
        type
        coordinates
      }
    }
  }
`;

export const NEIGHBOURING_PLOT_FRAGMENT = gql`
  fragment neighboringPlotValues on Plot {
    ...basePlotValues
    farm {
      ...baseFarmSiteValues
    }
  }
  ${BASE_PLOT_FRAGMENT}
  ${BASE_FARM_SITE_FRAGMENT}
`;

/**
 * Contains the base fragment of the farm site which excludes the cultivatedAreas
 */
export const PLOT_FRAGMENT = gql`
  fragment plotValues on Plot {
    ...basePlotValues
    farm {
      ...baseFarmSiteValues
    }
  }
  ${BASE_PLOT_FRAGMENT}
  ${BASE_FARM_SITE_FRAGMENT}
`;

export const EXTENDED_PLOT_FRAGMENT = gql`
  fragment extendedPlotValues on Plot {
    ...plotValues
    comments {
      edges {
        node {
          id
          plotId
          content
          userEmail
          createdTimestamp
          modifiedTimestamp
          createdBy {
            id
            name
          }
        }
      }
      count
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${PLOT_FRAGMENT}
  ${BASE_PARTNER_COMPANY_FRAGMENT}
  ${DOCUMENT_FRAGMENT}
`;
